import { AuthFailed } from "../../../tools/budgeaAPI";
import qs from "qs";

export async function parseLocation(client, location) {
  console.log("location.search", location.search);
  if (location.search) {
    let params = qs.parse(location.search.substring(1));
    // get and store user bi token
    console.log("queryParams params:", params);
    try {
      if (await client.handleCallback(params, "netwips")) {
        const access_token = client.getAccessToken();
        console.log("location.access_token", access_token);
      }
    } catch (e) {
      console.log("parseLocation error", e);
      if (e instanceof AuthFailed) {
        return;
      }

      throw e;
      // if (e instanceof StateInvalid) {
      //   // alert("StateInvalid");
      //   throw new Error("Etat invalide");
      // }
      // if (e instanceof AuthFailed) {
      //   // alert("AuthFailed");
      //   throw new Error("Authorisation invalide");
      //   // throw e;
      // }
      // if (e instanceof BadAccess) {
      //   // alert("AuthFailed");
      //   throw new Error("Bad Access");
      //   // throw e;
      // }
      // throw new Error("unknown error");
      // bad state
    }
  }
  console.log("location.search empty");
  return;
}

export async function getSettingsUrl(client, location) {
  const budgeaUrl = client.getSettingsUrl("netwips");
  return budgeaUrl;
}

export async function getBudgeaUrl(client, location) {
  //   const client = new BudgeaAPI("netwips2.biapi.pro", {
  //     redirect_uri: process.env.REACT_APP_BUDGEA_REDIRECTION_URL,
  //     client_id: process.env.REACT_APP_BUDGEA_CLIENT_ID,
  //     client_secret: process.env.REACT_APP_BUDGEA_CLIENT_SECRET
  //   });

  const budgeaUrl = client.getAuthenticationUrl("netwips");
  return budgeaUrl;
}
